<template>
  <Modal
    v-if="modals.gameState"
    class="game-state"
    @close="toggleModal('gameState')"
  >
    <h3>Game State JSON</h3>
    <!-- Typing here is kept apart from the live state until Load; its keys
         stay in the box so the app's shortcuts never see them. -->
    <textarea
      :value="liveJson"
      @input.stop="draft = $event.target.value"
      @keyup.stop
      @click="$event.target.select()"
    ></textarea>
    <div class="button-group">
      <div class="button townsfolk" @click="copy">
        <font-awesome-icon icon="copy" /> Copy
      </div>
      <div class="button demon" v-if="!session.isSpectator" @click="load">
        <font-awesome-icon icon="file-upload" /> Load
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Modal from "./Modal.vue";

export default {
  components: { Modal },
  data: () => ({
    // what the user typed; empty means "use the live state"
    draft: "",
  }),
  computed: {
    /** The whole table as the JSON users copy out and paste back later. */
    liveJson() {
      const { edition } = this;
      const official = Boolean(edition.isOfficial);
      const state = {
        edition: official ? { id: edition.id } : edition,
        roles: official ? "" : this.$store.getters.customRolesStripped,
        players: this.players.players.map((seat) => ({
          ...seat,
          role: seat.role.id || {},
        })),
        bluffs: this.players.bluffs.map((bluff) => bluff.id),
        fabled: this.players.fabled.map((fabled) =>
          fabled.isCustom ? fabled : { id: fabled.id },
        ),
      };
      return JSON.stringify(state, null, 2);
    },
    ...mapState(["modals", "players", "edition", "session"]),
  },
  methods: {
    copy() {
      navigator.clipboard.writeText(this.draft || this.liveJson);
    },
    load() {
      if (this.session.isSpectator) return;
      const { commit, state, getters } = this.$store;
      // the script's role by id, else any role the app knows, else nothing
      const scriptRole = (id) => state.roles.get(id);
      try {
        const { roles, edition, bluffs, fabled, players } = JSON.parse(
          this.draft || this.liveJson,
        );
        // roles before the edition: an official edition rebuilds its own set
        if (roles) commit("setCustomRoles", roles);
        if (edition) commit("setEdition", edition);
        if (bluffs && bluffs.length) {
          bluffs.forEach((id, index) =>
            commit("players/setBluff", { index, role: scriptRole(id) || {} }),
          );
        }
        if (fabled) {
          commit("players/setFabled", {
            fabled: fabled.map(
              (f) =>
                this.$store.state.fabled.get(f) ||
                this.$store.state.fabled.get(f.id) ||
                f,
            ),
          });
        }
        if (players) {
          commit(
            "players/set",
            players.map((seat) => ({
              ...seat,
              role:
                scriptRole(seat.role) ||
                getters.rolesJSONbyId.get(seat.role) ||
                {},
            })),
          );
        }
        this.toggleModal("gameState");
      } catch (error) {
        alert(`Could not read that game state JSON: ${error}`);
      }
    },
    ...mapMutations(["toggleModal"]),
  },
};
</script>

<style scoped lang="scss">
h3 {
  margin: 0 40px;
}

textarea {
  width: 60vw;
  max-width: 100%;
  height: 30vh;
  margin: 8px 0;
  color: white;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.5);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
</style>
